<template>
  <div class="merchant-add">
    <GlobalChunk icon="edit" title="门店信息编辑" :padding="[32, 0, 95, 55]">
      <div class="basics">
        <div class="flex_action">
          <div class="line"></div>
          <p style="color:#333333;margin-bottom: 0px;">基础信息</p>
        </div>
        <div><span>所属区域：</span> <span>{{ optionsProvince.areaName ? optionsProvince.areaName : '--' }}</span></div>
        <div><span>门店名称：</span> <span>{{ optionsProvince.storeName ? optionsProvince.storeName : '--' }}</span>
        </div>
        <div><span>门店店长：</span><span>{{ optionsProvince.storeManager ? optionsProvince.storeManager : '--' }}</span>
        </div>
        <div><span>联系方式：</span>
          <span>{{ optionsProvince.storeManagerPhone ? optionsProvince.storeManagerPhone : '--' }}</span>
        </div>
        <div>
          <span style="">回收方式：</span>
          <el-radio-group v-model="optionsProvince.recycleWay">
            <el-radio label="01">仅到店回收</el-radio>
            <el-radio label="02">到店及上门回收</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="basics flex_action" style="margin-bottom: 20px;">
        <div class="line"></div>
        <p style="color:#333333;">展示信息</p>
      </div>
      <div class="section_time">
        <span>*</span>
        <p>营业时间</p>
        <div style="width:200px;margin-right: 20px;">
          <el-time-select placeholder="起始时间" v-model="startTime" :picker-options="{
            start: '00:00',
            step: '00:30',
            end: '24:00'
          }">
          </el-time-select>
        </div>
        <p>~</p>
        <div style="width:200px;margin-left: 4px;">
          <el-time-select placeholder="结束时间" v-model="endTime" :picker-options="{
             start: '00:00',
            step: '00:30',
            end: '24:00',
            minTime: startTime
          }">
          </el-time-select>
        </div>

      </div>
      <el-row>
        <el-col :span="12">
          <GlobalForm :init-data="initData" :form-rules="formRules" :form-item-list="formItemList"
                      @handleConfirm="handleConfirm" confirmBtnName="提交">
            <div slot="storeAddress" class="store_address">
              <el-form-item required label="门店地址" label-width="95px" style="transform: translateX(-95px)">
                <el-input style="width: 80%" placeholder="输入门店详细地址（限50字内）" maxlength="50" v-model="storeAddress"></el-input>
                <span class="store_tips">
                  说明：按照门店实际地址填写
                </span>
              </el-form-item>

            </div>
            <div slot="storeLatAndLng" class="store_adress">
              <el-form-item required label="门店坐标" label-width="95px" style="transform: translateX(-95px)">
                <div class="map-inner">
                  <el-input style="width: 39%;" placeholder="点击“查询经纬度”，并将坐标数字串粘贴到此处" v-model="storeLatAndLng"></el-input>
                  <div class="map-content">
                    <img src="../../../assets/images/map.png" @click="isMap = true" alt="">
                    <span @click="isMap = true">查询经纬度</span>
                  </div>
                </div>
              </el-form-item>
            </div>
            <el-button slot="btnSlot" @click="FromBack">返回</el-button>
          </GlobalForm>
        </el-col>
      </el-row>
    </GlobalChunk>
    <el-dialog
        title="查询经纬度"
        :visible.sync="isMap"
        width="1400px"
    >
      <!-- 腾讯经纬度插入 -->
      <div style="padding-left: 26px; margin-bottom: 20px">
        <div
            style="
                width: 100%;
                height: 700px;
                overflow: hidden;
                border: 1px solid #dcdfe6;
                position: relative;
              "
        >
          <div
              class="map-picker-container"
              style="width: 100%; height: 800px; margin: -78px 0px 0px -2px"
          >
            <iframe
                src="https://lbs.qq.com/getPoint/"
                width="100%"
                height="800"
                scrolling="no"
            ></iframe>
          </div>
        </div>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="mapDialogVisible = false"
          >关 闭</el-button
        >
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
import {
  formValidateMobile,
  formValidateNumber,
  formValidateNumberEight,
} from '@/utils/form-validate'
import _api from '@/utils/request'
import {http} from "../../../utils/request/newIndex";

export default {
  name: 'merchant-add',
  data() {
    return {
      isMap:false,
      storeAddress: "",
      storeLatAndLng:"",
      sumitdata: '',
      checkRadio: 1,
      goolgeShow: false,
      startTime: "",
      endTime: "",
      // ShowUserAccount: false,
      MerchantFormData: [],
      optionsProvince: {},
      optionsCity: [],
      optionsArea: [],
      addressInfo: {
        provinceID: '',
        cityID: '',
        areaID: '',
      },
      initData: {
        // companyTime: null,
        storeAddress: '',
        infoImg: [],
        coverPicture: '',
        storeLatAndLng:''
      },
      formItemList: [
        // {
        //   key: 'companyTime',
        //   type: 'timePicker',
        //   labelName: '营业时间',
        //   placeholder: '输入营业时间',
        // },
        // {
        //   key: 'storeAddress',
        //   type: 'input',
        //   labelName: '门店地址',
        //   placeholder: '输入门店详细地址（限50字内）',
        // },
        {
          slotName: "storeAddress"
        },
        {
          slotName: "storeLatAndLng"
        },
        {
          key: 'coverPicture',
          type: 'upload',
          labelName: '门店封面图',
          limitSize: 10,
          placeholder:
              '最多支持上传1张图片，大小不超过10M，格式为JPG或PNG,建议尺寸100*100px',
        },
        {
          key: 'infoImg',
          type: 'uploadSome',
          labelName: '门店详情图',
          limitSize: 10,
          placeholder:
              '最多支持上传6张图片，大小不超过10M，格式为JPG或PNG,建议尺寸100*100px',
        },
      ],
      formRules: {
        // companyTime: [
        //   {
        //     required: true,
        //     trigger: 'blur',
        //     message: '请选择经营完整时间',
        //     max: 1000,
        //   },
        // ],
        storeAddress: [
          {
            required: true,
            trigger: 'change',
            message: '输入门店详细地址（限50字内）',
            max: 50,
          },
        ],
        coverPicture: [
          {
            required: true,
            trigger: "blur",
            message: "请上传门店封面图"
          }
        ],
        infoImg: [
          {
            required: true,
            trigger: "blur",
            message: "请上传门店详情图"
          }
        ],
      },
    }
  },
  mounted() {
    http.updateStoreinfo({id: this.$route.query.id}).then((res) => {
      if (res.code === 1) {
        console.log(res);
        const storeLat = res.data.storeLat??'';
        const storeLng = res.data.storeLng??'';
        this.optionsProvince = res.data
        this.storeAddress = this.optionsProvince.storeAddress
        this.initData.coverPicture = this.optionsProvince.coverPicture
        this.initData.infoImg = this.optionsProvince.infoImg.split(",")
        this.startTime = this.optionsProvince.startTime;
        this.endTime = this.optionsProvince.endTime;
        this.storeLatAndLng = storeLat+','+storeLng;
      }
    })
  },
  methods: {
    handleConfirm(data, cd) {
      // cd();
      console.log(data, this.startTime, this.endTime)
      this.sumitdata = data
      if (this.startTime && this.endTime) {
        this.optionsProvince.startTime = this.startTime;
        this.optionsProvince.endTime = this.endTime;
      } else {
        this.$message.error('请选择完整经营时间')
        return
      }
      if(!this.storeLatAndLng){
        return this.$message.error("请输入门店坐标");
      }
      const result = this.storeLatAndLng.split(',');
      if(result.length !== 2){
        return this.$message.error("你输入的门店坐标不正确")
      }
      this.optionsProvince.storeLng = result[1];
      this.optionsProvince.storeLat = result[0];
      this.optionsProvince.storeAddress = this.storeAddress;
      this.optionsProvince.infoImg = data.infoImg.join(",")
      this.optionsProvince.coverPicture = data.coverPicture;
      console.log(this.optionsProvince, "this.optionsProvince");
      this.sumitclick();
    },
    // changeTime(datas, type) {
    //   let data = datas.split(":")
    //    var hours =null
    //     // (data.getHours()) * (1000 * 60 * 60)
    //   if (data[0].split("")[0]=='0') {
    //     hours =data[0].split("")[1] * (1000 * 60 * 60)
    //   } else {
    //     hours = data[0] * (1000 * 60 * 60)
    //   }

    //   var minutes = null
    //   if (data[1] == '00') {
    //     minutes = 0
    //   } else {
    //     minutes = data[1] * (1000 * 60)
    //   }
    //   console.log(minutes,"minutes", data,hours);
    //   // hours = hours < 10 ? ('0' + hours) : hours;
    //   // minutes = minutes < 10 ? ('0' + minutes) : minutes;
    //   return hours + minutes;
    // },
    //提交按钮
    sumitclick() {
      console.log(this.optionsProvince);
      http.updatestoreList(this.optionsProvince).then((res) => {
        if (res.code === 1) {
          this.$router.push({path: '/OnlinreyService/OnlineStoreManagement'})
          this.$message({
            message: '编辑成功',
            type: 'success',
          })
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
          })
        }
      })
    },
    BeautifulClosed() {
      this.goolgeShow = false
    },

    FromBack() {
      this.$router.go(-1)
    },
  },
}
</script>

<style scoped lang="scss" ref="stylesheet/scss">
/deep/ .el-form-item__label {
  width: 95px !important;
}

.section_time {
  display: flex;
  align-items: center;
  margin-bottom: 18px;

  span {
    color: #FF687B;
    margin-right: 4px;
    margin-left: 15px;
  }

  p {
    font-size: 14px;
    color: #666666;
    padding-right: 16px;
  }

  width: 80%;
}

.basics {
  padding: 0 20px;
  margin-bottom: 35px;

  > div {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
  }

  p,
  span {
    font-size: 14px;
    color: #666666;
    margin-right: 20px
  }
}

.flex_action {
  display: flex;
  align-items: center;

  .line {
    width: 4px;
    height: 16px;
    background: #4966d2;
    margin-bottom: 0px;
    margin-right: 10px;
  }
}

.merchant-add {
  .el_from {
    margin-left: -120px;
  }
}

.el-dialog__body .acc_dialog_text1 {
  margin-bottom: 40 rpx;
  color: red;
}

.command {
  display: flex;
  align-items: center;
}

.command {
  display: flex;
  align-items: center;
}

.command .el-input {
  width: 80%;
}

/deep/ .el-select {
  width: 100%;
}

/deep/ .el-col-12{
  width: 70%;
}

.map-inner {
  font-size: 14px;
  color: #4C64EC;
  display: flex;
  align-items: center;
  font-weight: 700;
  cursor: pointer;
  >.map-content{
    display: flex;
    align-items: center;
    >img {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
  }
}

.map-loading {
  position: fixed;
  left: 50%;
  top: 50%;
  width: 60vw;
  height: 60vh;
  transform: translate(-50%, -50%);
  padding-top: 39px;
  background: #fff;

  > iframe {
    width: 100%;
    height: 100%;
  }
}

.map-close{
  position: absolute;
  right: 10px;
  top: 5px;
  font-size: 20px;
  color: #111;
  cursor: pointer;
}

.store_tips{
  color: #FF0F0F;
  font-size: 14px;
}

</style>
